import {FilterValuesType} from './actionTypes';

const setCommonFilterAction = (dispatch, data) => {
  dispatch({type: FilterValuesType.SET_COMMON_FILTERS, data});
};

export {setCommonFilterAction};
